import api from '../../utils/api';

export const fetchProducts = async (params) => {
  const response = await api.get('/products', { params });
  return response.data.data;
};

export const fetchProductBySlug = async (slug) => {
  const response = await api.get(`/products/${slug}`);
  return response.data.data;
};

export const fetchFeaturedProducts = async () => {
  const response = await api.get('/products/featured');
  return response.data.data;
};

export const fetchNewArrivals = async () => {
  const response = await api.get('/products/new-arrivals');
  return response.data.data;
};

export const fetchBestSellers = async () => {
  const response = await api.get('/products/best-sellers');
  return response.data.data;
};

export const fetchProductsByCategory = async (slug, params) => {
  const response = await api.get(`/products/category/${slug}`, { params });
  return response.data.data;
};

// Backend route is GET /products/:slug/related -> must be a slug, not an ObjectId.
export const fetchRelatedProducts = async (slug) => {
  const response = await api.get(`/products/${slug}/related`);
  return response.data.data;
};

export const searchProducts = async (params) => {
  const response = await api.get('/products/search', { params });
  return response.data.data;
};

export const fetchAutocomplete = async (query) => {
  const response = await api.get(`/products/autocomplete?q=${query}`);
  return response.data.data;
};

export const fetchCategories = async () => {
  const response = await api.get('/categories');
  return response.data.data;
};
